export enum TariffPrefix {
  G11 = 'G11',
  G12 = 'G12',
  G12w = 'G12w',
  G12as = 'G12as',
  G12r = 'G12r',
  G13 = 'G13',
  G13S = 'G13s',
  Dynamic = 'Dynamic',
}

export type TariffCheckboxesVisibleParams = {
  tariffName: string;
  isDouble?: boolean;
};

export enum HeatMapPriceType {
  SummerWork = 'SUMMER_WORK',
  SummerOffWork = 'SUMMER_OFF_WORK',
  WinterWork = 'WINTER_WORK',
  WinterOffWork = 'WINTER_OFF_WORK',
}

export type Segment = {
  pricingTier: number;
  value: number;
  start: number;
  end: number;
};
